export const GET_USER_TRANSACTION_START =
  'GET_USER_TRANSACTION_START';
export const GET_USER_TRANSACTION_SUCCESS =
  'GET_USER_TRANSACTION_SUCCESS';
export const GET_USER_TRANSACTION_ERROR =
  'GET_USER_TRANSACTION_ERROR';
